
import * as ipxStaticRuntime$onH6XZDRY1JTbu9BjFVEWaJp16e6TI_xMfSvn82UFJA from '/opt/atlassian/pipelines/agent/build/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$onH6XZDRY1JTbu9BjFVEWaJp16e6TI_xMfSvn82UFJA, defaults: {} }
}
        